<template>
  <div class="index-contain cont">
    <div class="header">
      <div class="m-tide">
        <div class="m-sunrise">
          <div>
            <em class="up"></em>
            <span>今日日出时间：{{sunUp}}</span>
          </div>
          <div>
            <em class="down"></em>
            <span>今日日落时间：{{sunDown}}</span>
          </div>
        </div>
        <!-- <div class="m-tideflow">
          <div>
            <em class="up"></em>
            <span>今日涨潮时间：{{tideUpTime}}（海洋局发布）</span>
          </div>
          <div>
            <em class="down"></em>
            <span>今日落潮时间：{{tideDownTime}}（海洋局发布）</span>
          </div>
        </div> -->
      </div>
      <img src="@/assets/img/logo.png" />智慧校园气象数据展示平台
      <div class="m-warning" v-if="warn.length > 0">
        <div class="warn-swiper" id="warn-swiper">
          <div class="warn_conten" v-for="(item,index) in warn" :key="index">
            <img :src="'./static/images/warning/'+item.warnType+'.jpg'" alt="">
            <div class="warn_txt">
              <h4>{{item.content}}</h4>
              <span>{{item.messager}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div>
        <div class="schoolname" v-if="userInfo.data">
          <label>{{ userInfo.data.schoolName }} </label>
          <div class="swiper-box">
            <div class="swiper-container" id="warningSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in warningObj" :key="index">
                  <img v-bind:src="
                      '../../../static/images/warning/' +
                      item.typeName +
                      '' +
                      item.level +
                      '.png'
                    " onerror="this.src='./static/images/err-img.png'" />
                </div>
                <!-- <div class="swiper-slide">
									<img src="@/assets/img/yj.png"  />
								</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="time">更新时间：{{ liveInformationObj.times }}</div>
        <div class="line"></div>
        <div class="detail">
          <div class="detail-say" v-if="liveInformationObj.temp">
            <label class="det-img"><img src="@/assets/img/temp.png" alt="" /></label>
            <label>气温：<span>{{ liveInformationObj.temp }}</span></label>
          </div>

          <div class="detail-say" v-if="liveInformationObj.xdsd">
            <label class="det-img"><img src="@/assets/img/sd.png" alt="" /></label>
            <label>相对湿度：<span>{{ liveInformationObj.xdsd }}</span></label>
          </div>
          <div class="detail-say" v-if="liveInformationObj.pressure">
            <label class="det-img"><img src="@/assets/img/qy.png" alt="" /></label>
            <label>气压：<span>{{ liveInformationObj.pressure }}</span></label>
          </div>
          <div class="detail-say" v-if="liveInformationObj.windDirectionObj">
            <label class="det-img"><img src="@/assets/img/windd.png" alt="" /></label>
            <label>风速：<span>{{
                liveInformationObj.windDirectionObj
              }}</span></label>
          </div>
          <div class="detail-say" v-if="liveInformationObj.windPowerObj">
            <label class="det-img"><img src="@/assets/img/windv.png" alt="" /></label>
            <label>风向：<span>{{ liveInformationObj.windPowerObj }}</span></label>
          </div>

          <div class="detail-say" v-if="liveInformationObjxsjs">
            <label class="det-img"><img src="@/assets/img/yl.png" alt="" /></label>
            <label>整点以来降水：<span>{{ liveInformationObjxsjs }}</span></label>
          </div>
          <div class="detail-say">
            <label class="det-img"><img src="@/assets/img/yl.png" alt="" /></label>
            <label>近12小时雨量：
              <span>{{ rain12sum }}毫米</span>
            </label>
          </div>
          <div class="detail-say">
            <label class="det-img"><img src="@/assets/img/yl.png" alt="" /></label>
            <label>近24小时雨量：
              <span>{{rain24sum }}毫米</span>
            </label>
          </div>
          <div class="detail-say" v-if="liveVisibility">
            <label class="det-img"><img src="@/assets/img/njd-icon.png" alt="" /></label>
            <label>能见度：<span>{{liveVisibility}}</span></label>
          </div>
          <div class="detail-say" v-if="liveInformationObjrzgqw">
            <label class="det-img"><img src="@/assets/img/rzgqw-icon.png" alt="" /></label>
            <label>日最高气温(出现时间)：
              <p>{{ liveInformationObjrzgqw }}</p>
            </label>
          </div>
          <div class="detail-say" v-if="liveInformationObjrzgqw">
            <label class="det-img"><img src="@/assets/img/rzdqw-icon.png" alt="" /></label>
            <label>日最低气温(出现时间)：
              <p>{{ liveInformationObjrzdqw }}</p>
            </label>
          </div>
          <div class="detail-say" v-if="liveInformationObj.rjdfs">
            <label class="det-img"><img src="@/assets/img/windd.png" alt="" /></label>
            <label>日极大风速(出现时间)：
              <p>{{ liveInformationObj.rjdfs }}</p>
            </label>
          </div>
          <div class="detail-title">气象要素</div>
        </div>
      </div>
      <div>
        <div class="tutu">
          <div class="tutu-name">{{ minTimes }}—{{ maxTimes }}要素曲线图</div>
          <div class="tuechart" id="valuechart"></div>
        </div>
        <div class="tutu2">
          <div class="sevenechart  nomgb">
            <div class="daynight div">
              <div>白<br />天</div>
              <div>夜<br />晚</div>
            </div>
            <div class="div" v-for="(item,index) in weekData.date" :key="index">
              <div class="week">{{weekData.date[index]}}</div>
              <div class="date">{{weekData.time[index]}}</div>
              <div class="imgsay">
                <img :src='"@/assets/img/weather/day/"+ weekData.weatherD[index] +".png"' alt="">
              </div>
              <div class="imgsay0">
                <img :src='"@/assets/img/weather/night/"+ weekData.weatherN[index] +".png"'>
              </div>
            </div>

            <div class="sevenechartcont" id='sevenchart'></div>
            <div class="sevenechartcont" id='sevenchartN'></div>
          </div>
          <div class="qiuechart">
            <h4>海洋潮汐预报</h4>
            <div class="swiper-container" id="qiuechartSwiper">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="tide-content">
                    <div class="m-tide-swiper">
                      <div>第一高潮：</div>
                      <div class="tide-data">
                        <p>潮高{{tideData.FirstHighFTide}}厘米</p>
                        <p>出现时间{{tideData.FirstHighTideTime}}</p>
                      </div>
                    </div>
                    <div class="m-tide-swiper">
                      <div>第一低潮：</div>
                      <div class="tide-data">
                        <p>潮高{{tideData.FirstLowFTide}}厘米</p>
                        <p>出现时间{{tideData.FirstLowTideTime}}</p>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="swiper-slide">
                  <div class="tide-content">
                    <div class="m-tide-swiper">
                      <div>第二高潮：</div>
                      <div class="tide-data">
                        <p>潮高{{tideData.SecondHighFTide}}厘米</p>
                        <p>出现时间{{tideData.SecondHighTideTime}}</p>
                      </div>
                    </div>
                    <div class="m-tide-swiper">
                      <div>第二低潮：</div>
                      <div class="tide-data">
                        <p>潮高{{tideData.SecondLowFTide}}厘米</p>
                        <p>出现时间{{tideData.SecondLowTideTime}}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="add">
              <img src="@/assets/img/qiu.png" alt="" />
            </div>
          </div>
        </div>
        <div class="tutu3">
          <p>北仑区气象台{{forcastDataTime}}发布</p>
          <div>潮高基准面：85国家高程</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/img/cs.png" />
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
import echartsLiquidfill from "echarts-liquidfill"; //在这里引入
var that;
export default {
  name: "Index",
  data: function () {
    return {
      valuechart: "",
      sevenchart: "",
      rollechart: "",
      rollechart1: "",
      rollechartObj: "",
      rollechart1Obj: "",
      icons: [
        require("@/assets/img/wds.png"),
        require("@/assets/img/ws.png"),
        require("@/assets/img/yls.png"),
        require("@/assets/img/fengxiang.png"),
      ],
      userInfo: {}, //用户信息
      liveInformationObj: {}, //实况
      weekData: {}, //七天
      minTimes: "", //24小时数据最小时间
      maxTimes: "", //24小时数据最大时间
      swiperShow: true, //判断是否存在预警
      warningObj: {},
      stationNumArrNum: "",//学校编号
      liveInformationObjxsjs: "",//实况小时降水
      liveInformationObjrzgqw: "",//实况最高气温
      liveInformationObjrzdqw: "",//实况最低气温
      liveVisibility: '',//能见度
      timer: null,//自动刷新
      forcastDataTime: "",
      warn: [
        // {warnType:"暴雨橙色",content:"北仑区气象台2021年5月20日12时51分发布发布暴雨黄色预警信号",messager:"受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天受强对流云团影响，我区上游已出现30毫米以上短时暴雨，预计今天傍晚到夜里我区部分地区将出现短时大到暴雨，请注意防范。"}
      ],//北仑预警信息
      sunUp: "",
      sunDown: "",
      tideUpTime: "",
      tideDownTime: "",
      rain12sum: 0,
      rain24sum: 0,
      tideData: {},
    };
  },

  mounted() {
    that = this;
    var query = decodeURI(window.location.search.substring(1));
    var vars = query.split(/\?|\&|\=/g);
    var b = {};
    for (var i = 0; i < vars.length; i = i + 2) {
      b[vars[i]] = vars[i + 1];
    }

    if (vars[0] == "") {
      this.userInfo = {
        key: "k2393",
      };
    } else {
      this.userInfo = b;
    }
    //获取区域地点
    that.getcityObj();
    that.getTideDate();


    //自动刷新
    that.timer = setInterval(() => {
      that.$router.go(0);
    }, 300000)
  },
  methods: {
    //获取区域地点
    getcityObj() {
      var that = this;
      requestData("./static/data/user.json", "get", "", function (res) {
        var b = res[that.userInfo.key];
        that.$set(that.userInfo, "data", b);
        that.stationNumArrNum = b.stationNum;
        // that.getMapWarning(that.userInfo.data.areaName);
        that.getOndayObj(that.userInfo.data.stationNum);
        document.title = that.userInfo.data.schoolName;
        //实况
        that.getRealWeather("minute", "stationPress,dryBulTemp,windVelocity,windDirect,relHumidity,exMaxWindV,timeExMaxWind", "stationDataInfo");
        //visibility
        that.getvisibilityWeather();
        //七天
        that.getOndayObj(that.stationNumArrNum);
        //预警
        that.getWarning();
        //小时降水
        that.getRealWeather('hour', 'precipitation', "stationDataInfo");
        //日最大最小气温和风
        that.getRealWeather('day', 'maxTemp,timeMaxTemp,minTemp,timeMinTemp,exMaxWindV,timeExMaxWind', "stationDataInfo");
        //统计数据（水球）
        that.getRealWeather('hourEx', 'sumPrecipitation12hH,sumPrecipitation24hH', "stationDataWithTimeInfo");
      });
    },
    //潮汐数据
    getTideDate() {
      let that = this;
      var url = "http://nbocean.metgs.com:58080/nboceanpublish/api/index.php/api/fcst/getFcstTide";
      url = "http://radar.grassinfo.cn:8818/apiTest/nbwechat/appid/dataposition?url=" + url
      requestData(
        url, "get", {
        data: JSON.stringify({
          stid: "WL_BLG",
          ptime: new Date().format("yyyy-MM-dd hh") + ":00:00"
        })
      }, function (res) {
        that.tideData = res.data[0];
        var swiper = new Swiper("#qiuechartSwiper", {
          initialSlide: 0,
          autoplay: {
            disableOnInteraction: false, //默认true
            delay: 2000, //默认3000
          },
          slidesPerView: 1,
          spaceBetween: 30,
          centeredSlides: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        });
      })

      var xhr = new XMLHttpRequest()
      xhr.open('get', './static/data/sunTabel.xls', true)
      xhr.responseType = 'arraybuffer'
      let _this = this
      xhr.onload = function (e) {
        if (xhr.status === 200) {
          var data = new Uint8Array(xhr.response)
          var workbook = XLSX.read(data, { type: 'array' })
          console.log(workbook)

          var sheetNames = workbook.SheetNames // 工作表名称集合
          _this.workbook = workbook
          _this.card = sheetNames
          _this.cardActive = sheetNames[0]
          _this.getTable(sheetNames[0])
        }
      }
      xhr.send()
    },
    getTable(sheetName) {
      var worksheet = this.workbook.Sheets[sheetName]
      let tableData = XLSX.utils.sheet_to_json(worksheet)
      let dayNow = new Date().getDate();
      let monthNow = new Date().Format("MM") * 1;
      this.sunUp = tableData[dayNow][monthNow + "月日出"];
      this.sunDown = tableData[dayNow][monthNow + "月日落"];
    },
    // 实况
    getRealWeather(scale, elements, urlsrc) {
      var that = this;
      var data = {
        stationNum: that.stationNumArrNum, //
        scale: scale,
        observTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        elements: elements,
        token: "21e18d88850a4b16ad8e6222de1f68f9",
      };
      if (scale != "day") {
        requestData(
          baseUrlDpnew + "/station-service/" + urlsrc + "/getStationData",
          "get",
          data,
          function (res) {
            if (res.code == 0) {
              var resData = res.data;
              if (scale == 'minute') {
                that.liveInformationObj.temp = resData.dryBulTemp ? resData.dryBulTemp + "℃" : "",
                  
                  that.liveInformationObj.xdsd = resData.relHumidity ? resData.relHumidity + "%" : "",
                  that.liveInformationObj.pressure = resData.stationPress ? parseInt(resData.stationPress) / 10 + "百帕" : "",
                  that.liveInformationObj.windDirectionObj = resData.dryBulTemp ? flObj(resData.windVelocity) + "(" + resData.windVelocity + "米/秒)" : "",
                  that.liveInformationObj.windPowerObj = resData.dryBulTemp ? fxnumobj(resData.windDirect) : "",
                  that.liveInformationObj.times = res.time;
                //气象要素
                that.getElementObj();
              } else if (scale == 'hour') {
                if (elements == "precipitation") {
                  that.liveInformationObjxsjs = res.data.precipitation || res.data.precipitation == 0 ? res.data.precipitation + "毫米" : "";
                } else {
                  that.liveInformationObjrzgqw = res.data.maxTemp ? res.data.maxTemp + "℃(" + that.isYesterday(res.data.timeMaxTemp) + ")" : "";
                  that.liveInformationObjrzdqw = res.data.minTemp ? res.data.minTemp + "℃(" + that.isYesterday(res.data.timeMinTemp) + ")" : "";
                }
              } else {
                that.rain12sum = resData.sumPrecipitation12hH;
                that.rain24sum = resData.sumPrecipitation24hH;
              }
            }
          });
      }else{
        data.scale = "hour";
         requestData(
          baseUrlDpnew + "/station-service/stationDataInfo/getStationDayData",
          "get",
          data,
          function (res) {
            var resData = res.data;
            that.liveInformationObj.rjdfs = resData.exMaxWindV ? flObj(resData.exMaxWindV.exMaxWindV) + "(" + resData.exMaxWindV.exMaxWindV + "米/秒)" + "(" + that.isYesterday(resData.exMaxWindV.timeExMaxWind) + ")" : "";
            that.liveInformationObjrzgqw = resData.maxTemp ?  resData.maxTemp.maxTemp + "℃(" + that.isYesterday(resData.maxTemp.timeMaxTemp) + ")" : "";
            that.liveInformationObjrzdqw = resData.minTemp ? resData.minTemp.minTemp + "℃(" + that.isYesterday(resData.minTemp.timeMinTemp) + ")" : "";
          })
      }

    },
    getWarning() {
      // /**startmarquee(一次滚动高度,速度,停留时间);**/
      // // startmarquee(100, 60, 1000);
      // return;
      var that = this;
      var url = "https://stwx.qx121.com/nbtfwx/nbqx/forecastwarn/getValidWarnList";
      var arr = [];
      requestData(url, "get", "", function (data) {
        data.map(function (item) {
          if (item.publishstation.indexOf('北仑') > -1 && item.content.indexOf("解除") == -1) {
            item.warnType = item.type + item.level;
            arr.push(item);
          }
        })
        that.warn = arr;
        if (arr.length > 0) {
          that.$nextTick(function () {
            /**startmarquee(一次滚动高度,速度,停留时间);**/
            startmarquee(100, 60, 1000);
          })
        }
      })
    },
    //实况能见度
    getvisibilityWeather() {
      let that = this;
      var data = {
        stationNum: 'k2373',
        token: '21e18d88850a4b16ad8e6222de1f68f9'
      }
      requestData(
        baseUrlDpnew + "/station-service/stationDataInfo/getStationVisData",
        "get",
        data,
        function (res) {
          if (res.code == 0) {
            var resData = res.data
            that.liveVisibility = resData.visibility && that.userInfo.key == 'k2394' ? resData.visibility + "米" : "";
          }
        })
    },
    //七天
    getOndayObj(userArea) {
      var that = this;
      var d = {
        date: [],
        time: [],
        weatherD: [],
        weatherN: [],
        windD: [],
        windF: [],
        maxTemp: [],
        minTemp: [],
      };
      var url = encodeURIComponent("https://stwx.qx121.com/nbwx/weather/data/58563.json");
      requestData(
        "http://radar.grassinfo.cn:8818/apiTest/nbwechat/appid/position?url=" + url,
        "get",
        "",
        function (result) {
          var res = result["7day"].data;
          var weekend = ["日", "一", "二", "三", "四", "五", "六"];
          if (res.length > 0) {
            res.map(function (item, index) {
              if (item.date == new Date().format("yyyy-MM-dd")) {
                d.date.push("今天");
              } else {
                let date = item.date;
                date = "星期" + weekend[new Date(date).getDay()];
                d.date.push(date);
              }
              let date = new Date(item.date).format("MM-dd")
              d.time.push(date);
              d.weatherD.push(item.day.weather);
              d.weatherN.push(item.night.weather);
              d.maxTemp.push(item.day.maxTemp);
              d.minTemp.push(item.day.minTemp);
            });
          }
          that.weekData = d;
          that.forcastDataTime = result["7day"].reprotTime;
          that.weatherChart(d.maxTemp, "#sevenchart");
          that.weatherChart(d.minTemp, "#sevenchartN");
        }
      );
    },
    //气象要素
    getElementObj() {
      let that = this;
      var obj = {};
      var xarr = [], rainArr = [], tempArr = [], windSpeedList = [];
      var data = {
        stationNum: that.stationNumArrNum, //
        scale: 'minute',
        observTime: new Date().format("yyyy-MM-dd hh:mm:ss"),
        elements: 'dryBulTemp,windVelocity,windDirect,precipitation',
        token: "21e18d88850a4b16ad8e6222de1f68f9",
      };
      requestData(baseUrlDpnew + '/station-service/stationDataInfo/getStationData24H', 'get', data, function (res) {
        if (res.code == 0) {
          var resData = res.data;
          for (var i = 0; i < resData.length; i++) {
            xarr.push(resData[i].time.slice(8, 10) + '日' + resData[i].time.slice(11, 13) + '时');
            rainArr.push(resData[i].precipitation == '000000' ? 0 : resData[i].precipitation);
            tempArr.push(resData[i].dryBulTemp == '000000' ? null : resData[i].dryBulTemp);
            obj = {
              // value: parseInt(flObj(resData[i].windVelocity)),
              value: resData[i].windVelocity,
              symbol: 'image://http://radar.grassinfo.cn:8818/apiTest/api/windRod/getWindPole?angle=' + resData[i].windDirect + '&velocity=' + resData[i].windVelocity + '&color=rgb(255,255,255)',
              symbolSize: 40
            }
            windSpeedList.push(obj);
          }
          xarr.reverse();
          console.log(xarr)
          that.maxTimes = resData[0].time.split(" ")[0].split("-")[1] + '月' + resData[0].time.split(" ")[0].split("-")[2] + '日' + resData[0].time.split(" ")[1].split(":")[0] + '时';
          that.minTimes = resData[resData.length - 1].time.split(" ")[0].split("-")[1] + '月' + resData[resData.length - 1].time.split(" ")[0].split("-")[2] + '日' + resData[resData.length - 1].time.split(" ")[1].split(":")[0] + '时'
          that.drawyaosuEchart(xarr, rainArr, tempArr, windSpeedList);
        }
      })


    },
    //绘制要素图表
    drawyaosuEchart(xarr, rainArr, tempArr, windSpeedList) {
      let that = this;
      var dom = document.querySelector("#valuechart");
      that.valuechart = that.$echarts.init(dom);
      var colors = ["#FD7EBA", "#ffe2a9", "#56bdff"];
      var option = {
        color: colors,
        title: {
          text: '更新时间：' + that.liveInformationObj.times,
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: "normal",
          },
          right: "10%",
        },
        tooltip: {
          trigger: "axis",
          position: function (pos, params, dom, rect, size) {
            return [
              pos[0] - size.contentSize[0] / 2,
              pos[1] - size.contentSize[1],
            ];
          },
          textStyle: {
            fontSize: 9,
          },
        },
        grid: {
          right: "10%",
          top: 80,
          bottom: 24,
          left: "5%",
        },
        legend: {
          data: [
            {
              name: "温度（℃）",
              icon: "image://" + that.icons[0],
            },
            {
              name: "风速（米/秒）",
              icon: "image://" + that.icons[1],
            },
            {
              name: "雨量（毫米）",
              icon: "image://" + that.icons[2],
            },
          ],
          selected: {
            "温度（℃）": true,
            "风速（米/秒）": true,
            "雨量（毫米）": true,
          },
          right: "10%",
          top: 24,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              textStyle: {
                //改变刻度字体样式
                color: "#fff",
                fontSize: 12, //x轴文字大小
              },

              formatter: function (value) {
                return value.slice(3, 5) + '时';
              },
            },
            data: xarr,
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              //网格线
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: " ℃",
            min: function (value) {
              return 0;
            },
            max: function (value) {
              return value.max;
            },
            position: "right",
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              //网格线
              show: false,
            },
            axisLabel: {
              // formatter: '{value} ml'
            },
          },
          {
            type: "value",
            name: "米/秒",
            splitLine: {
              //网格线
              show: false,
            },
            minInterval: 1,
            min: function (value) {
              return value.min;
            },
            max: function (value) {
              return value.max;
            },
            position: "right",
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            offset: 50,
            axisLabel: {
              // formatter: '{value} °C'
            },
          },
          {
            type: "value",
            name: "毫米",
            splitLine: {
              //网格线
              show: false,
            },
            min: function (value) {
              return value.min;
            },
            max: function (value) {
              return value.max;
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              // formatter: '{value} ml'
            },
          },
        ],
        series: [
          {
            name: "温度（℃）",
            type: "line",
            smooth: true,
            data: tempArr,
            lineStyle: {
              color: "#FD7EBA",
            },
            symbolSize: 0,
            label: {
              show: false,
              color: "#fff",
              fontSize: 12,
            },
          },
          {
            name: "风速（米/秒）",
            type: "line",
            yAxisIndex: 1,
            symbol: "arrow",
            symbolOffset: [0, -3.5],
            symbolSize: 12,
            data: windSpeedList,
            lineStyle: {
              normal: {
                color: "#ffe2a9",
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ["#ffe2a9", "transparent"];
                  if (params.data.value == 0) {
                    return colorList[1];
                  } else {
                    return colorList[0];
                  }
                },
              },
            },
          },
          {
            name: "雨量（毫米）",
            type: "bar",
            yAxisIndex: 2,
            data: rainArr,
            itemStyle: {
              barBorderRadius: [20, 20, 0, 0],
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#6deaeb", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#529eb3", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#2d5061", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              show: false,
              color: "#fff",
              fontSize: 12,
              position: "top",
            },
          },
        ],
      };
      that.valuechart.setOption(option);
      window.setTimeout(function () {
        that.valuechart.resize();
      }, 200);
    },
    //绘制七天图表
    weatherChart(data, id) {
      var dom = document.querySelector(id);
      that.sevenchart = that.$echarts.init(dom);
      var option = {
        color: ["#37A2DA", "#9FE6B8"],
        grid: {
          top: "30",
          bottom: "30",
          left: "8%",
          right: "8%",
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            show: false,
          },
        ],
        yAxis: [
          {
            type: "value",
            show: false,
            min: function (value) {
              return value.min;
            },
            max: function (value) {
              return value.max;
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            data: data,
            showSymbol: true,
            symbolSize: 8,
            symbol: "circle",
            hoverAnimation: true,
            smooth: true,
            itemStyle: {
              normal: {
                color: id == "#sevenchartN" ? "#9ce5f1" : "#c5a8f7",//"#9ce5f1", //改变折线点的颜色
                lineStyle: {
                  color: id == "#sevenchartN" ? "#71c7d5" : "#9d72e4",//"#71c7d5", //改变折线颜色
                },
                label: {
                  show: true,
                  formatter: function (val) {
                    //yOldData
                    return val.value + "℃";
                  },
                  textStyle: {
                    color: "#fff",
                  },
                  position: id == "#sevenchartN" ? "bottom" : "top",
                },
              },
            },
          },
        ],
      };
      that.sevenchart.setOption(option);
      window.setTimeout(function () {
        that.sevenchart.resize();
      }, 200);
    },

    //绘制水球图表
    drawballEchart(item) {
      var dom = document.querySelector(".rollechart");
      that.rollechart = that.$echarts.init(dom);
      if (item == null || item == "000000") {
        var value = null;
      } else {
        var value = item;
      }
      var option = {
        series: [
          {
            type: "liquidFill", //类型
            radius: "80%",
            data: value == null || value == '0' || value == '0.0' ? [0, 0] : [0.4, 0.4], //数据是个数组 数组的每一项的值是0-1
            outline: {
              show: true, //是否显示轮廓 布尔值
              borderDistance: 0, //外部轮廓与图表的距离 数字
              itemStyle: {
                //borderColor:'#5aa9d1', //边框的颜色
                borderColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(85, 144, 176, 1)",
                    },
                    {
                      offset: 0.5,
                      color: "rgba(85, 144, 176, .25)",
                    },
                    {
                      offset: 1,
                      color: "rgba(85, 144, 176, 1)",
                    },
                  ],
                  globalCoord: false,
                },
                borderWidth: 0, //边框的宽度
                //shadowBlur: 25 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
                //shadowColor: '#000' //外部轮廓的阴影颜色
              },
            },
            backgroundStyle: {
              //color:'rgba(36,71,95,0.5)',//图表的背景颜色
              color: {
                type: "linear",
                x: 1,
                y: 0,
                x2: 0.5,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(36,71,95, 0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(36,71,95, .25)",
                  },
                  {
                    offset: 0,
                    color: "rgba(36,71,95, 1)",
                  },
                ],
                globalCoord: false,
              },
              // borderWidth: '1',//图表的边框宽度
              // borderColor: '#000',//图表的边框颜色
              shadowBlur: 5, //外部轮廓的阴影范围 一旦设置了内外都有阴影
              shadowColor: "#000", //外部轮廓的阴影颜色
              // itemStyle: {
              //     shadowBlur:100,//设置无用
              //     shadowColor: '#64bbe5',//设置无用
              //     opacity: 1 //设置无用
              // }
            },
            itemStyle: {
              opacity: 1, //波浪的透明度
              // shadowBlur:0,//波浪的阴影范围
              // shadowColor:'#64bbe5',//阴影颜色
            },
            label: {
              fontSize: 16,
              color: "#fff",
              fontWeight: "normal",
              formatter: function (param) {
                var paramVal;
                if (param.value == null) {
                  paramVal = "暂无数据";
                } else {
                  paramVal = param.value == 0 ? "0.0毫米" : param.value + "毫米";
                }
                return "近12小时雨量" + "\n\n" + "\n" + paramVal;
              },
            },
            emphasis: {
              itemStyle: {
                opacity: 1, //鼠标经过波浪颜色的透明度
              },
            },
            color: ["#acf9fe", "#64bbe5"],
            // color: ['#64bbe5'],//水波的颜色 对应的是data里面值
            // shape: 'circle',//水填充图的形状 circle默认圆形  rect圆角矩形  triangle三角形  diamond菱形  pin水滴状 arrow箭头状  还可以是svg的path
            center: ["50%", "50%"], //图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
            radius: "98%", //图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
            amplitude: "6%", //振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
            waveLength: "88%",
            // phase:0 ,//波的相位弧度 默认情况下是自动
            // period: (value,index)=>{//控制波的移动速度 可以是函数 也可以是数字 两个参数  value 是data数据里面的值 index 是data值的索引

            //     return index*2000;
            // },
            direction: "left", //波移动的速度 两个参数  left 从右往左 right 从左往右
            waveAnimation: true, //控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
            animationEasing: "linear", //初始动画
            animationEasingUpdate: "quarticInOut", //数据更新的动画效果
            animationDuration: 3000, //初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
            animationDurationUpdate: 300, //数据更新动画的时长
          },
        ],
        //backgroundColor: 'rgba(255,0,0,0.1)'容器背景颜色
      };
      that.rollechart.setOption(option);
      window.setTimeout(function () {
        that.rollechart.resize();
      }, 200);
    },
    //绘制水球图表
    drawballEchart1(item) {
      var dom = document.querySelector(".rollechart1");
      that.rollechart1 = that.$echarts.init(dom);
      if (item == null || item == "000000") {
        var value = null;
      } else {
        var value = item;
      }
      var option = {
        series: [
          {
            type: "liquidFill", //类型
            radius: "80%",
            data: value == null || value == '0' || value == '0.0' ? [0, 0] : [0.4, 0.4], //数据是个数组 数组的每一项的值是0-1
            outline: {
              show: true, //是否显示轮廓 布尔值
              borderDistance: 0, //外部轮廓与图表的距离 数字
              itemStyle: {
                //borderColor:'#5aa9d1', //边框的颜色
                borderColor: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(85, 144, 176, 1)",
                    },
                    {
                      offset: 0.5,
                      color: "rgba(85, 144, 176, .25)",
                    },
                    {
                      offset: 1,
                      color: "rgba(85, 144, 176, 1)",
                    },
                  ],
                  globalCoord: false,
                },
                borderWidth: 0, //边框的宽度
                //shadowBlur: 25 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
                //shadowColor: '#000' //外部轮廓的阴影颜色
              },
            },
            backgroundStyle: {
              //color:'rgba(36,71,95,0.5)',//图表的背景颜色
              color: {
                type: "linear",
                x: 1,
                y: 0,
                x2: 0.5,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(36,71,95, 0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(36,71,95, .25)",
                  },
                  {
                    offset: 0,
                    color: "rgba(36,71,95, 1)",
                  },
                ],
                globalCoord: false,
              },
              // borderWidth: '1',//图表的边框宽度
              // borderColor: '#000',//图表的边框颜色
              shadowBlur: 5, //外部轮廓的阴影范围 一旦设置了内外都有阴影
              shadowColor: "#000", //外部轮廓的阴影颜色
              // itemStyle: {
              //     shadowBlur:100,//设置无用
              //     shadowColor: '#64bbe5',//设置无用
              //     opacity: 1 //设置无用
              // }
            },
            itemStyle: {
              opacity: 1, //波浪的透明度
              // shadowBlur:0,//波浪的阴影范围
              // shadowColor:'#64bbe5',//阴影颜色
            },
            label: {
              fontSize: 16,
              color: "#fff",
              fontWeight: "normal",
              formatter: function (param) {
                var paramVal;
                if (param.value == null) {
                  paramVal = "暂无数据";
                } else {
                  paramVal = param.value == 0 ? "0.0毫米" : param.value + "毫米";
                }
                return "近24小时雨量" + "\n\n" + "\n" + paramVal;
              },
            },
            emphasis: {
              itemStyle: {
                opacity: 1, //鼠标经过波浪颜色的透明度
              },
            },
            color: ["#acf9fe", "#64bbe5"],
            // color: ['#64bbe5'],//水波的颜色 对应的是data里面值
            // shape: 'circle',//水填充图的形状 circle默认圆形  rect圆角矩形  triangle三角形  diamond菱形  pin水滴状 arrow箭头状  还可以是svg的path
            center: ["50%", "50%"], //图表相对于盒子的位置 第一个是水平的位置 第二个是垂直的值 默认是[50%,50%]是在水平和垂直方向居中 可以设置百分比 也可以设置具体值
            radius: "98%", //图表的大小 值是圆的直径 可以是百分比 也可以是具体值 100%则占满整个盒子 默认是40%; 百分比下是根据宽高最小的一个为参照依据
            amplitude: "6%", //振幅 是波浪的震荡幅度 可以取具体的值 也可以是百分比 百分比下是按图标的直径来算
            waveLength: "88%",
            // phase:0 ,//波的相位弧度 默认情况下是自动
            // period: (value,index)=>{//控制波的移动速度 可以是函数 也可以是数字 两个参数  value 是data数据里面的值 index 是data值的索引

            //     return index*2000;
            // },
            direction: "left", //波移动的速度 两个参数  left 从右往左 right 从左往右
            waveAnimation: true, //控制波动画的开关  值是布尔值 false 是关闭动画 true 是开启动画 也是默认值
            animationEasing: "linear", //初始动画
            animationEasingUpdate: "quarticInOut", //数据更新的动画效果
            animationDuration: 3000, //初始动画的时长，支持回调函数，可以通过每个数据返回不同的 delay 时间实现更绚丽的初始动画效果
            animationDurationUpdate: 300, //数据更新动画的时长
          },
        ],
        //backgroundColor: 'rgba(255,0,0,0.1)'容器背景颜色
      };
      that.rollechart1.setOption(option);
      window.setTimeout(function () {
        that.rollechart1.resize();
      }, 200);
    },
    isYesterday(date) {
      let hour = date.split(":")[0];
      let nowHour = new Date().getHours();
      if (hour > nowHour) {
        return "昨" + date
      } else {
        return date
      }
    }
  },
};

function startmarquee(lh, speed, delay) {
  var t;
  var oHeight = 190; /** div的高度 **/
  var p = false;
  var o = document.getElementById("warn-swiper");
  var preTop = 0;
  o.scrollTop = 0;

  function start() {
    t = setInterval(scrolling, speed);
    o.scrollTop += 1;
  }

  function scrolling() {
    if (o.scrollTop % lh != 0 && o.scrollTop % (o.scrollHeight - oHeight - 1) != 0) {
      preTop = o.scrollTop;
      o.scrollTop += 1;
      if (preTop >= o.scrollHeight || preTop == o.scrollTop) {
        o.scrollTop = 0;
      }
    } else {
      clearInterval(t);
      setTimeout(start, delay);
    }
  }
  setTimeout(start, delay);
}
</script>

<style scoped>
body,
html {
  font-size: 12px !important;
}

.index-contain {
  background: #275f73;
  height: 100%;
  position: relative;
}

.header {
  width: 100%;
  background-color: #367b94;
  height: 1.01rem;
  line-height: 1.01rem;
  font-size: 0.3rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: relative;
  z-index: 99;
}

.header img {
  height: 0.58rem;
  width: 0.58rem;
  vertical-align: middle;
  margin-right: 0.18rem;
}

.container {
  position: absolute;
  top: 1.01rem;
  width: 100%;
  z-index: 2;
  /* bottom:0; */
  height: calc(100% - 1.01rem);
  box-sizing: border-box;
  padding-left: 1.68rem;
  padding-right: 0.58rem;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* IE 10+ */
}

.container::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.container > div {
  float: left;
  padding-top: 0.47rem;
}

.container > div:nth-child(1) {
  width: 3.23rem;
  min-height: 2rem;
  /* overflow: hidden; */
}

.schoolname {
  color: #fff;
  font-size: 0.26rem;
  font-family: PingFangSC;
  font-weight: 500;
  line-height: 0.37rem;
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: space-around;
}

.schoolname label {
  color: #fff;
  font-weight: bold;
}

.time {
  font-size: 0.16rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: #fff;
  text-align: center;
  margin-top: 0.11rem;
  margin-bottom: 0.03rem;
}

.line {
  width: 100%;
  height: 0.03rem;
  background: linear-gradient(90deg, #9dedff 0%, #bde595 100%);
}

.detail {
  padding-left: 0.76rem;
  padding-top: 0.18rem;
  position: relative;
}

.detail-say {
  margin-bottom: 0.16rem;
  display: flex;
}
.detail-say label p {
  text-align: left;
  font-weight: bold;
}
.nomgb {
  margin-bottom: 0 !important;
}

.det-img {
  height: 0.33rem;
  width: 0.32rem;
  overflow: hidden;
  text-align: center;
  display: inline-block;
  margin-right: 0.2rem;
}

.detail-say img {
  display: inline-block;
  vertical-align: middle;
  height: 0.28rem;
}

.detail-say label {
  color: #fff;
  line-height: 0.33rem;
  font-size: 0.18rem;
  font-family: PingFangSC;
  font-weight: normal;
  letter-spacing: 0.001rem;
  white-space: nowrap;
}
.detail-say label span {
  font-weight: bold;
}
.detail-title {
  position: absolute;
  top: 50%;
  left: -0.1rem;
  font-size: 0.24rem;
  padding-left: 0.09rem;
  padding-right: 0.09rem;
  height: 1.32rem;
  background: #479ed1;
  border-radius: 0.25rem;
  color: #fff;
  margin-top: -0.66rem;
  writing-mode: tb;
  text-align: center;
}

.short {
  height: 1.07rem !important;
  margin-top: -0.535rem !important;
}

.container > div:nth-child(2) {
  width: calc(100% - 3.23rem);
  padding-left: 0.26rem;
  box-sizing: border-box;
}

@media (max-width: 1366px) {
  .container > div:nth-child(2) {
    width: calc(100% - 3.53rem);
  }

  .container > div:nth-child(1) {
    width: 3.53rem;
  }

  .detail-say label {
    font-size: 0.23rem;
  }

  .detail-title {
    left: -0.08rem;
  }
}

.tutu-name {
  font-size: 0.28rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: #fff;
  text-align: center;
}

.tuechart {
  width: 100%;
  height: 3.4rem;
}

.tutu2 {
  display: flex;
}

.tutu2 .sevenechart {
  width: 8.16rem;
  min-height: 3.37rem;
  margin-top: 0.3rem;
  margin-bottom: 0.49rem;
  overflow: hidden;
  position: relative;
}

.sevenechartcont {
  position: absolute;
  right: 0;
  left: 1.02rem;
  top: 1.1rem;
  bottom: 1.5rem;
}

.sevenechart > .div {
  width: 1.02rem;
  float: left;
  text-align: center;
  min-height: 3.37rem;
  color: #fff;
  border-right: 1px solid #f3f3f3;
  box-sizing: border-box;
}

.sevenechart > div:last-child {
  border: 0;
}

.sevenechart > div > div {
  color: #fff;
}

.week {
  font-size: 0.22rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
}

.date {
  font-size: 0.22rem;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  margin-top: 0.18rem;
}

.imgsay,
.imgsay0 {
  text-align: center;
  margin-top: 0.1rem;
}

.imgsay0 {
  margin-top: 0.7rem;
}
#sevenchartN {
  top: 2.3rem;
  bottom: 0.2rem;
}
.imgsay img,
.imgsay0 img {
  width: 0.42rem;
  height: 0.42rem;
}

.daynight {
  height: 100%;
}

.daynight > div:nth-child(1) {
  height: 50%;
  padding-top: 0.6rem;
  /* 	padding-bottom:0.401rem; */
  box-sizing: border-box;
}

.daynight > div:nth-child(2) {
  height: 50%;
  padding-top: 0.401rem;
  box-sizing: border-box;
}

.qiuechart {
  width: 3.12rem;
  height: 3.12rem;
  margin-top: 0.52rem;
  margin-left: 0.69rem;
  position: relative;
  border-radius: 50%;
  border: 3px solid rgba(85, 144, 176, 0.5);
  overflow: hidden;
}

.add {
  position: absolute;
  top: 3px;
  left: 3px;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  text-align: right;
  border-radius: 50%;
  padding-right: 0.5rem;
  padding-top: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 30px #12232e inset;
}

.add img {
  width: 1.4rem;
  height: 0.95rem;
}

.rollechart,
.rollechart1,
.rollechart2,
.rollechart3,
.rollechart4 {
  width: 3.12rem;
  height: 3.12rem;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  opacity: 0.85;
}

.footer img {
  width: 100%;
  vertical-align: bottom;
}

.swiper-box,
.swiper-box .swiper-container,
.swiper-box .swiper-container img {
  width: 0.47rem;
  height: 0.39rem;
}

.swiper-box .swiper-slide {
  height: 0.39rem;
}

#qiuechartSwiper {
  width: 100%;
  height: 100%;
}

#qiuechartSwiper .swiper-slide {
  text-align: center;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.tutu3 {
  margin-top: 12px;
  display: flex;
  text-align: right;
}
.tutu3 p {
  width: 8.16rem;
}
.tutu3 div {
  width: 3.2rem;
}
.m-warning {
  position: absolute;
  height: 100%;
  overflow: hidden;
  right: 30px;
  top: 0;
  width: 6.3rem;
}
.warn_conten {
  display: flex;
  align-items: center;
  padding: 10px 0;
  position: relative;
}
.warn-swiper {
  height: 100%;
  width: 100%;
  padding-right: 50px;
  overflow: auto;
}
.m-warning img {
  width: 0.72rem;
  height: 0.6rem;
  margin-right: 0.2rem;
  position: absolute;
  top: 0.2rem;
}
.warn_txt h4 {
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  line-height: 26px;
  margin-bottom: 8px;
  text-align: left;
}
.warn_txt span {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #fff;
  display: block;
  text-align: left;
}
.warn_txt {
  width: 5.38rem;
  margin-left: 0.92rem;
}
.m-tide {
  width: 31%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0.15rem 0.2rem;
}
.m-tide span {
  font-size: 0.2rem;
  line-height: 0;
}
.m-sunrise,
.m-tideflow {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.m-sunrise > div,
.m-tideflow > div {
  height: 50%;
  display: flex;
  align-items: center;
}
.m-tide em {
  display: block;
  background-size: 100% 100%;
  margin-right: 7px;
}
.m-sunrise em.up {
  width: 24px;
  height: 18px;
  background-image: url("../../assets/img/sun-up.png");
}
.m-sunrise em.down {
  width: 26px;
  height: 20px;
  background-image: url("../../assets/img/sun-down.png");
}
.m-tideflow em.up {
  width: 18px;
  height: 20px;
  background-image: url("../../assets/img/tide-up.png");
}
.m-tideflow em.down {
  width: 18px;
  height: 20px;
  background-image: url("../../assets/img/tide_down.png");
}
.qiuechart h4 {
  font-size: 0.24rem;
  line-height: 0.24rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  top: 0.58rem;
}
.m-tide-swiper {
  font-size: 0.18rem;
  display: flex;
  line-height: 0.18rem;
  text-align: left;
  margin-bottom: 0.25rem;
}
.tide-data {
  margin-left: 4px;
}
.tide-content {
  position: relative;
  top: 0.28rem;
}
.tide-data p:not(:last-child) {
  margin-bottom: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/page/dpnew/dpnew.vue